import crop_list from "./crop_list";

const plots = {

        // Titles
        title: String("Parcelas"),
        plotsTableTitle: String("Gestión de mis parcelas"),
        
        // Table headers
        plotName: String("Nombre de la parcela"),
        plotCropId: String("Tipo de cultivo"),
        plotTerrainBelongs: String("Terreno asociado"),
        plotActionHeader: String("Acciones"),

        // Buttons
        plotNewPlotButton: String("Crear nueva parcela"),
        plotPlotActionModify: String("Modificar"),

        // Modal
        deletePromptModalTitle: String("Eliminar parcela"),
        deleteModalBody: String("Estas apunto de eliminar una parcela. Una vez eliminada sera imposible restaurarla. Seguro que quieres eliminarla?"),
        deleteModalAccept: String("Eliminar"),
        deleteModalRejec: String("Cancelar"),
};
plots.crop_list = crop_list;

export default plots;